import { BaseEntity } from './baseEntity';

export  class EntityContainer<E extends BaseEntity> {

  row : E;

  constructor(type: (new () => E)){
    this.row          =  new type();
    this.row.inserted = true;
    this.row.edit     = true;
  }

}

